const actions = {
    READ_PUBLIC_CONTACT_PROFILE_REQUEST: 'READ_PUBLIC_CONTACT_PROFILE_REQUEST',
    READ_PUBLIC_CONTACT_PROFILE_SUCCESS: 'READ_PUBLIC_CONTACT_PROFILE_SUCCESS',
    READ_PUBLIC_CONTACT_PROFILE_ERROR: 'READ_PUBLIC_CONTACT_PROFILE_ERROR',
    UPDATE_PUBLIC_CONTACT_PROFILE_REQUEST: 'UPDATE_PUBLIC_CONTACT_PROFILE_REQUEST',
    UPDATE_PUBLIC_CONTACT_PROFILE_SUCCESS: 'UPDATE_PUBLIC_CONTACT_PROFILE_SUCCESS',
    UPDATE_PUBLIC_CONTACT_PROFILE_ERROR: 'UPDATE_PUBLIC_CONTACT_PROFILE_ERROR',

    getPublicContactProfile: () => ({
        type: actions.READ_PUBLIC_CONTACT_PROFILE_REQUEST,
    }),
    updatePublicContactProfile: request => ({
        type: actions.UPDATE_PUBLIC_CONTACT_PROFILE_REQUEST,
        request,
    }),
};

export default actions;
